var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 188,
    viewBox: "0 0 250 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4375 0.25C17.2215 0.25 11.2601 2.7193 6.86468 7.11469C2.4693 11.5101 0 17.4715 0 23.6875L0 54.9375H93.75C95.822 54.9375 97.8091 55.7606 99.2743 57.2257C100.739 58.6909 101.562 60.678 101.562 62.75C101.562 66.7031 102.812 72.8125 106.344 77.7188C109.578 82.2188 115.047 86.1875 125 86.1875C134.953 86.1875 140.422 82.2188 143.656 77.7188C147.188 72.8125 148.438 66.7031 148.438 62.75C148.438 60.678 149.261 58.6909 150.726 57.2257C152.191 55.7606 154.178 54.9375 156.25 54.9375H250V23.6875C250 17.4715 247.531 11.5101 243.135 7.11469C238.74 2.7193 232.779 0.25 226.562 0.25H23.4375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250 70.5625H163.266C162.145 76.4209 159.785 81.972 156.344 86.8437C150.203 95.375 140.047 101.812 125 101.812C109.953 101.812 99.7969 95.375 93.6562 86.8437C90.2154 81.9718 87.8554 76.4208 86.7344 70.5625H0V164.312C0 170.529 2.4693 176.49 6.86468 180.885C11.2601 185.281 17.2215 187.75 23.4375 187.75H226.562C232.779 187.75 238.74 185.281 243.135 180.885C247.531 176.49 250 170.529 250 164.312V70.5625Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.c04a5a24a28bc1595821305cd7759c3e.svg";
export { ForwardRef as ReactComponent };